var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageHeader',{attrs:{"title":_vm.title,"icon":_vm.icon,"back":"","print":""},on:{"back":function($event){return _vm.$emit('back')},"print":_vm.print}},[_c('div',{attrs:{"id":"printTarget"}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }